function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import { computePosition as ot, flip as st, autoPlacement as rt } from "../../../../../@floating-ui_core@1.7.2/node_modules/@floating-ui/core/dist/floating-ui.core.js";
import { createCoords as w, rectToClientRect as J, floor as A, max as E, round as H, min as z } from "../../../../../@floating-ui_utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.js";
import { getOverflowAncestors as M, isElement as v, getDocumentElement as O, getWindow as L, getFrameElement as K, getComputedStyle as R, isHTMLElement as b, isWebKit as Q, isTopLayer as S, getParentNode as W, isLastTraversableNode as N, isTableElement as ct, isContainingBlock as Y, getContainingBlock as lt, getNodeName as _, isOverflowElement as P, getNodeScroll as I } from "../../../../../@floating-ui_utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.js";
function Z(t) {
  var e = R(t);
  var n = parseFloat(e.width) || 0,
    i = parseFloat(e.height) || 0;
  var o = b(t),
    r = o ? t.offsetWidth : n,
    s = o ? t.offsetHeight : i,
    c = H(n) !== r || H(i) !== s;
  return c && (n = r, i = s), {
    width: n,
    height: i,
    $: c
  };
}
function $(t) {
  return v(t) ? t : t.contextElement;
}
function F(t) {
  var e = $(t);
  if (!b(e)) return w(1);
  var n = e.getBoundingClientRect(),
    _Z = Z(e),
    i = _Z.width,
    o = _Z.height,
    r = _Z.$;
  var s = (r ? H(n.width) : n.width) / i,
    c = (r ? H(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
var ft = w(0);
function X(t) {
  var e = L(t);
  return !Q() || !e.visualViewport ? ft : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function ut(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== L(t) ? !1 : e;
}
function T(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var o = t.getBoundingClientRect(),
    r = $(t);
  var s = w(1);
  e && (i ? v(i) && (s = F(i)) : s = F(t));
  var c = ut(r, n, i) ? X(r) : w(0);
  var l = (o.left + c.x) / s.x,
    f = (o.top + c.y) / s.y,
    u = o.width / s.x,
    h = o.height / s.y;
  if (r) {
    var p = L(r),
      a = i && v(i) ? L(i) : i;
    var x = p,
      g = K(x);
    for (; g && i && a !== x;) {
      var m = F(g),
        d = g.getBoundingClientRect(),
        y = R(g),
        C = d.left + (g.clientLeft + parseFloat(y.paddingLeft)) * m.x,
        B = d.top + (g.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, f *= m.y, u *= m.x, h *= m.y, l += C, f += B, x = L(g), g = K(x);
    }
  }
  return J({
    width: u,
    height: h,
    x: l,
    y: f
  });
}
function q(t, e) {
  var n = I(t).scrollLeft;
  return e ? e.left + n : T(O(t)).left + n;
}
function tt(t, e, n) {
  n === void 0 && (n = !1);
  var i = t.getBoundingClientRect(),
    o = i.left + e.scrollLeft - (n ? 0 : q(t, i)),
    r = i.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function ht(t) {
  var e = t.elements,
    n = t.rect,
    i = t.offsetParent,
    o = t.strategy;
  var r = o === "fixed",
    s = O(i),
    c = e ? S(e.floating) : !1;
  if (i === s || c && r) return n;
  var l = {
      scrollLeft: 0,
      scrollTop: 0
    },
    f = w(1);
  var u = w(0),
    h = b(i);
  if ((h || !h && !r) && ((_(i) !== "body" || P(s)) && (l = I(i)), b(i))) {
    var a = T(i);
    f = F(i), u.x = a.x + i.clientLeft, u.y = a.y + i.clientTop;
  }
  var p = s && !h && !r ? tt(s, l, !0) : w(0);
  return {
    width: n.width * f.x,
    height: n.height * f.y,
    x: n.x * f.x - l.scrollLeft * f.x + u.x + p.x,
    y: n.y * f.y - l.scrollTop * f.y + u.y + p.y
  };
}
function at(t) {
  return Array.from(t.getClientRects());
}
function dt(t) {
  var e = O(t),
    n = I(t),
    i = t.ownerDocument.body,
    o = E(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth),
    r = E(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  var s = -n.scrollLeft + q(t);
  var c = -n.scrollTop;
  return R(i).direction === "rtl" && (s += E(e.clientWidth, i.clientWidth) - o), {
    width: o,
    height: r,
    x: s,
    y: c
  };
}
function gt(t, e) {
  var n = L(t),
    i = O(t),
    o = n.visualViewport;
  var r = i.clientWidth,
    s = i.clientHeight,
    c = 0,
    l = 0;
  if (o) {
    r = o.width, s = o.height;
    var f = Q();
    (!f || f && e === "fixed") && (c = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: c,
    y: l
  };
}
var pt = new Set(["absolute", "fixed"]);
function mt(t, e) {
  var n = T(t, !0, e === "fixed"),
    i = n.top + t.clientTop,
    o = n.left + t.clientLeft,
    r = b(t) ? F(t) : w(1),
    s = t.clientWidth * r.x,
    c = t.clientHeight * r.y,
    l = o * r.x,
    f = i * r.y;
  return {
    width: s,
    height: c,
    x: l,
    y: f
  };
}
function j(t, e, n) {
  var i;
  if (e === "viewport") i = gt(t, n);else if (e === "document") i = dt(O(t));else if (v(e)) i = mt(e, n);else {
    var o = X(t);
    i = {
      x: e.x - o.x,
      y: e.y - o.y,
      width: e.width,
      height: e.height
    };
  }
  return J(i);
}
function et(t, e) {
  var n = W(t);
  return n === e || !v(n) || N(n) ? !1 : R(n).position === "fixed" || et(n, e);
}
function wt(t, e) {
  var n = e.get(t);
  if (n) return n;
  var i = M(t, [], !1).filter(function (c) {
      return v(c) && _(c) !== "body";
    }),
    o = null;
  var r = R(t).position === "fixed";
  var s = r ? W(t) : t;
  for (; v(s) && !N(s);) {
    var c = R(s),
      l = Y(s);
    !l && c.position === "fixed" && (o = null), (r ? !l && !o : !l && c.position === "static" && !!o && pt.has(o.position) || P(s) && !l && et(t, s)) ? i = i.filter(function (u) {
      return u !== s;
    }) : o = c, s = W(s);
  }
  return e.set(t, i), i;
}
function xt(t) {
  var e = t.element,
    n = t.boundary,
    i = t.rootBoundary,
    o = t.strategy;
  var s = [].concat(_toConsumableArray(n === "clippingAncestors" ? S(e) ? [] : wt(e, this._c) : [].concat(n)), [i]),
    c = s[0],
    l = s.reduce(function (f, u) {
      var h = j(e, u, o);
      return f.top = E(h.top, f.top), f.right = z(h.right, f.right), f.bottom = z(h.bottom, f.bottom), f.left = E(h.left, f.left), f;
    }, j(e, c, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function yt(t) {
  var _Z2 = Z(t),
    e = _Z2.width,
    n = _Z2.height;
  return {
    width: e,
    height: n
  };
}
function vt(t, e, n) {
  var i = b(e),
    o = O(e),
    r = n === "fixed",
    s = T(t, !0, r, e);
  var c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var l = w(0);
  function f() {
    l.x = q(o);
  }
  if (i || !i && !r) if ((_(e) !== "body" || P(o)) && (c = I(e)), i) {
    var a = T(e, !0, r, e);
    l.x = a.x + e.clientLeft, l.y = a.y + e.clientTop;
  } else o && f();
  r && !i && o && f();
  var u = o && !i && !r ? tt(o, c) : w(0),
    h = s.left + c.scrollLeft - l.x - u.x,
    p = s.top + c.scrollTop - l.y - u.y;
  return {
    x: h,
    y: p,
    width: s.width,
    height: s.height
  };
}
function V(t) {
  return R(t).position === "static";
}
function G(t, e) {
  if (!b(t) || R(t).position === "fixed") return null;
  if (e) return e(t);
  var n = t.offsetParent;
  return O(t) === n && (n = n.ownerDocument.body), n;
}
function nt(t, e) {
  var n = L(t);
  if (S(t)) return n;
  if (!b(t)) {
    var o = W(t);
    for (; o && !N(o);) {
      if (v(o) && !V(o)) return o;
      o = W(o);
    }
    return n;
  }
  var i = G(t, e);
  for (; i && ct(i) && V(i);) i = G(i, e);
  return i && N(i) && V(i) && !Y(i) ? n : i || lt(t) || n;
}
var Rt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(t) {
    var e, n, i;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          e = this.getOffsetParent || nt;
          n = this.getDimensions;
          _context.next = 4;
          return n(t.floating);
        case 4:
          i = _context.sent;
          _context.t0 = vt;
          _context.t1 = t.reference;
          _context.next = 9;
          return e(t.floating);
        case 9:
          _context.t2 = _context.sent;
          _context.t3 = t.strategy;
          _context.t4 = (0, _context.t0)(_context.t1, _context.t2, _context.t3);
          _context.t5 = {
            x: 0,
            y: 0,
            width: i.width,
            height: i.height
          };
          return _context.abrupt("return", {
            reference: _context.t4,
            floating: _context.t5
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, this);
  }));
  return function Rt(_x) {
    return _ref.apply(this, arguments);
  };
}();
function Ot(t) {
  return R(t).direction === "rtl";
}
var bt = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ht,
  getDocumentElement: O,
  getClippingRect: xt,
  getOffsetParent: nt,
  getElementRects: Rt,
  getClientRects: at,
  getDimensions: yt,
  getScale: F,
  isElement: v,
  isRTL: Ot
};
function it(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Ct(t, e) {
  var n = null,
    i;
  var o = O(t);
  function r() {
    var c;
    clearTimeout(i), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), r();
    var f = t.getBoundingClientRect(),
      u = f.left,
      h = f.top,
      p = f.width,
      a = f.height;
    if (c || e(), !p || !a) return;
    var x = A(h),
      g = A(o.clientWidth - (u + p)),
      m = A(o.clientHeight - (h + a)),
      d = A(u),
      C = {
        rootMargin: -x + "px " + -g + "px " + -m + "px " + -d + "px",
        threshold: E(0, z(1, l)) || 1
      };
    var B = !0;
    function k(U) {
      var D = U[0].intersectionRatio;
      if (D !== l) {
        if (!B) return s();
        D ? s(!1, D) : i = setTimeout(function () {
          s(!1, 1e-7);
        }, 1e3);
      }
      D === 1 && !it(f, t.getBoundingClientRect()) && s(), B = !1;
    }
    try {
      n = new IntersectionObserver(k, _objectSpread(_objectSpread({}, C), {}, {
        root: o.ownerDocument
      }));
    } catch (_unused) {
      n = new IntersectionObserver(k, C);
    }
    n.observe(t);
  }
  return s(!0), r;
}
function Ft(t, e, n, i) {
  i === void 0 && (i = {});
  var _i = i,
    _i$ancestorScroll = _i.ancestorScroll,
    o = _i$ancestorScroll === void 0 ? !0 : _i$ancestorScroll,
    _i$ancestorResize = _i.ancestorResize,
    r = _i$ancestorResize === void 0 ? !0 : _i$ancestorResize,
    _i$elementResize = _i.elementResize,
    s = _i$elementResize === void 0 ? typeof ResizeObserver == "function" : _i$elementResize,
    _i$layoutShift = _i.layoutShift,
    c = _i$layoutShift === void 0 ? typeof IntersectionObserver == "function" : _i$layoutShift,
    _i$animationFrame = _i.animationFrame,
    l = _i$animationFrame === void 0 ? !1 : _i$animationFrame,
    f = $(t),
    u = o || r ? [].concat(_toConsumableArray(f ? M(f) : []), _toConsumableArray(M(e))) : [];
  u.forEach(function (d) {
    o && d.addEventListener("scroll", n, {
      passive: !0
    }), r && d.addEventListener("resize", n);
  });
  var h = f && c ? Ct(f, n) : null;
  var p = -1,
    a = null;
  s && (a = new ResizeObserver(function (d) {
    var _d = _slicedToArray(d, 1),
      y = _d[0];
    y && y.target === f && a && (a.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(function () {
      var C;
      (C = a) == null || C.observe(e);
    })), n();
  }), f && !l && a.observe(f), a.observe(e));
  var x,
    g = l ? T(t) : null;
  l && m();
  function m() {
    var d = T(t);
    g && !it(g, d) && n(), g = d, x = requestAnimationFrame(m);
  }
  return n(), function () {
    var d;
    u.forEach(function (y) {
      o && y.removeEventListener("scroll", n), r && y.removeEventListener("resize", n);
    }), h !== null && h !== void 0 && h(), (d = a) == null || d.disconnect(), a = null, l && cancelAnimationFrame(x);
  };
}
var Wt = rt,
  Bt = st,
  Dt = function Dt(t, e, n) {
    var i = new Map(),
      o = _objectSpread({
        platform: bt
      }, n),
      r = _objectSpread(_objectSpread({}, o.platform), {}, {
        _c: i
      });
    return ot(t, e, _objectSpread(_objectSpread({}, o), {}, {
      platform: r
    }));
  };
export { Wt as autoPlacement, Ft as autoUpdate, Dt as computePosition, Bt as flip, M as getOverflowAncestors, bt as platform };